<template>
  <div class="search_index_wapr">
    <img src="@/assets/image/back.png" alt class="left" @click="goBack" />
    <div :class="{'center60':showType=='search'}" class="center">
      <van-image :src="serchIcon" width="16" height="16"></van-image>
      <span class="text" v-show="showType=='none'"  @click="jumpSearch">搜索店铺内商品</span>
      <input type="search" v-model="searchValue" v-show="showType=='search'" class="input_search" placeholder="搜索店铺内商品"/>
    </div>
    <img
      src="@/assets/image/brandico.png"
      alt
      class="left"
      @click="shareGoods"
      v-show="showType=='none'"
    />
    <span
      class="search_btn"
      v-show="showType=='search' && show=='1'"
      @click="onSearchResult"
    >{{show=='1'?'搜本店':''}}</span>
  </div>
</template>
<script>
import utils from "@/utils/common";
export default {
  data() {
    return {
      serchIcon: require("@/assets/home/serchicon.png"),
      searchValue: "",
      listRefShow: false
    };
  },
  props: {
    brandId: {
      default: 0,
      type: [Number, String]
    },
    showType: {
      default: "none",
      type: String
    },
    show: {
      default: "1",
      type: String
    }
  },
  methods: {
    shareGoods() {
       this.$minicode.show({pageCode:'5010301',pageQueryParam:this.$route.query});
      if (this.brandId) {
        utils.shareGoods("", "", "", "", "brand", this.brandId + "");
      }
    },
    goBack() {
      this.$minicode.show({pageCode:'5010301',pageQueryParam:this.$route.query});
      utils.goBack();
    },
    onSearch(val) {
      this.onSearchResult(val);
    },
    onSearchResult(val) {
      if (this.searchValue.trim()) {
        this.$emit("changeKeyWord", this.searchValue);
      }
    },
    jumpSearch(){
      if(process.env.NODE_ENV !== 'production') {
        this.$router.push({
          name: 'home'
        })
        return
      }
      let url = window.location.origin +'/h5user/brandsearch?brandId='+this.brandId; 
      utils.jumpToNewPage({
        url:url,
        noTitle:'1'
      })
      
    }
  }
};
</script>
<style lang="less" scoped>
.search_index_wapr {
  padding: 0 20px;
  display: flex;
  background-color: #fff;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  .left {
    width: 44px;
    height: 44px;
    img {
      width: 100%;
    }
  }
  .left-icon-image{
    width:32px;
    height: 32px;
    padding-left: 20px;
  }
  img {
    width: 44px;
    height: 44px;
  }
  .search_btn {
    font-size: 24px;
    color: #333;
    display: block;
    text-align: center;
    background-color: #f8d541;
    padding: 13px 29px;
    box-sizing: border-box;
    border-radius: 30px;
    margin-left: 23px;
  }
  .bg {
    background-color: #fff !important;
  }
  .center {
    width: 80%;
    background-color: #f7f7f7;
    border-radius: 38px;
    height: 70px;
    font-size: 24px;
    padding-left: 29px;
    color: #999;
    display: flex;
    align-items: center;
    .text {
      padding-left: 10px;
    }
    .right-item {
      line-height: 70px;
    }
    .input_search{
      width: 95%;
      background: none;
      padding: 10px 9px;
      box-sizing: border-box;
      color: #999;
      border: 0px;
      &::-webkit-input-placeholder{
        color: #999;
      }
    }
  }
  .center60{
    width: 65%;
  }
}
/deep/.van-search__content {
  padding-left: 0;
  font-size: 24px;
}
/deep/.van-field__control {
  font-size: 24px;
}
/deep/ .van-search {
  padding: 0;
 
}
</style>
